module.exports = __webpack_public_path__ + "img/mapEN.77e84f02.png";